import { Box, Grid, Typography, styled } from "@mui/material";
import React from "react";
import { primary } from "../../../constants/theme";

const CustomerKeySpecifications = styled(Box)(({ theme }) => ({
  //   width: "100vw",
  //   display: "flex",
  //   alignItems: "center",
  //   //minHeight: "500px",
  //   flexDirection: "column",
  paddingLeft: "9%",
  paddingRight: "9%",
  //marginTop: "48px",
  //paddingTop: "12px",
  ".vehicles-grid-container": {
    padding: "20px",
    display: "flex",
    justifyContent: "flex-start",
  },
  ".promiseHeader": {
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "0em",
    textAlign: "left",
  },

  ".question": {
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "22px",
    display: "flex",
    flexDirection: "row",
    lineHeight: "32xpx",
    color: primary.black,
    width: "88%",
    justifyContent: "flex-start",
    margin: "8px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    //marginTop: "24px",

    ".promiseHeader": {
      fontSize: "24px",
    },

    ".vehicles-grid-container": {
      padding: "10px",
    },

    ".question": {
      fontSize: "14px",
      lineHeight: "24px",
      margin: "8px",
    },
  },
}));

const KeySpecifications = ({ keySpecifications, headerInfo }) => {
  const keyLength = parseInt(keySpecifications?.length / 2);

  const info1 = keySpecifications?.slice(0, keyLength);
  const info2 = keySpecifications?.slice(keyLength);

  return (
    <CustomerKeySpecifications>
      <Typography className="promiseHeader" style={{ paddingBottom: "10px" }}>
        {headerInfo}
      </Typography>
      <Grid
        container
        className="vehicles-grid-container"
        id="search-result"
        style={{
          border: `1px solid ${primary?.lightGrey} `,
          borderRadius: "8px",
        }}
      >
        {info1?.map((res, index) => (
          <Grid item xs={12} md={6} lg={6} key={index}>
            <Box className="question">
              <span
                style={{
                  marginRight: "12px",
                  fontWeight: "100",
                  color: primary?.main,
                }}
              >
                {res?.icon}
              </span>

              <Box dangerouslySetInnerHTML={{ __html: `${res?.info}` }} />
            </Box>
          </Grid>
        ))}

        {info2?.map((res, index) => (
          <Grid item xs={12} md={6} lg={6} key={index}>
            <Box className="question">
              <span
                style={{
                  marginRight: "12px",
                  fontWeight: "100",
                  color: primary?.main,
                }}
              >
                {res?.icon}
              </span>
              <Box dangerouslySetInnerHTML={{ __html: `${res?.info}` }} />

              {/* {`${res?.info}`} */}
            </Box>
          </Grid>
        ))}
      </Grid>
    </CustomerKeySpecifications>
  );
};

const MemoizedKeySpecifications = React.memo(KeySpecifications);
export default MemoizedKeySpecifications;
